import * as React from 'react';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { getId } from 'office-ui-fabric-react/lib/Utilities';
import { IConfimationBoxProps, IConfimationBoxState } from '../../../../interfaces/IConfimationBox';


export default class ConfimationBox extends React.Component<IConfimationBoxProps, IConfimationBoxState> {

    private _labelId: string = getId('dialogLabel');
    private _subTextId: string = getId('subTextLabel');

    constructor(props: IConfimationBoxProps) {
        super(props);
    }

    private _closeDialog = (): void => {
        this.setState({ hideDialog: true });
    };


    public render() {
        return (
            <div>
                <Dialog
                    hidden={this.props.hideDialog}
                    onDismiss={()=>this.props._no(this.props.isConfirmed)}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: this.props.title,
                        subText: this.props.subTitle
                    }}
                    modalProps={{
                        titleAriaId: this._labelId,
                        subtitleAriaId: this._subTextId,
                        isBlocking: false,
                        styles: { main: { maxWidth: 450 } }
                    }}
                >
                    {this.props.children}
                    <DialogFooter>
                        <DefaultButton onClick={()=>this.props._no(this.props.isConfirmed)} text={this.props.noText} />
                        <PrimaryButton
                            onClick={() => this.props._yes(this.props.isConfirmed)}
                            text={this.props.yesText} />
                    </DialogFooter>
                </Dialog>
            </div>
        );
    }
}
